import _objectSpread from "/builds/huggg/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { translateObject } from '@huggg/bar-staff';
import { prop } from 'ramda';
import { urls } from '../../config';
import { brandMap, paginatedResponseMap, productMap, reportsTransactionMap } from '../../translationMaps';
import getParams from '../../utils/getParams';
import withAxios from '../../utils/with-axios';

/**
 * Accepted filter columns.
 *
 * @var {Object} filterColumnMap
 */
var filterColumnMap = {
  brand: 'brand',
  dateFrom: 'date_from',
  dateTo: 'date_to',
  orderId: 'order_id',
  purchase: 'purchase',
  transactionId: 'transaction_id',
  type: 'type',
  types: 'types'
};

/**
 * Accepted sort columns.
 *
 * @var {Object} sortColumnMap
 */
var sortColumnMap = {
  brand: 'brand',
  date: 'date',
  orderId: 'order_id',
  product: 'product',
  transactionId: 'transaction_id',
  type: 'type',
  types: 'types'
};

/**
 * Format the response data to convert snake_case to camelCase, and rename some
 * columns using the mappings provided.
 *
 * @param {Object} data API response data
 * @returns {Object} Formatted response data
 */
function formatAllResponse(data) {
  var penceFactor = 100;
  var translated = translateObject(paginatedResponseMap, data);
  if (translated.data.length) {
    var translatedData = translated.data.map(function (item) {
      if (item.brand) {
        item.brand = translateObject(brandMap, item.brand);
      }
      if (item.product) {
        item.product = translateObject(productMap, item.product);
      }
      return _objectSpread(_objectSpread({}, translateObject(reportsTransactionMap, item)), {}, {
        redeemedValue: item.redeemedValue / penceFactor,
        refundedValue: item.refundedValue / penceFactor,
        stashedValue: item.stashedValue / penceFactor,
        sentValue: item.sentValue / penceFactor,
        totalValue: item.totalValue / penceFactor
      });
    });
    translated.data = translatedData;
  }
  return translated;
}

/**
 * Get transaction report data for a given user. This endpoint attaches the
 * brand and product to the returned data items. This endpoint is paginated.
 *
 * transactionReports.allByUserId().then(data => { ... })
 * transactionReports.allByUserId(axiosInstance).then(data => { ... })
 * transactionReports.allByUserId({page: 2}).then(data => { ... })
 * transactionReports.allByUserId({
 *   filter: { dateFrom: '2019-01-01', dateTo: '2019-12-31 },
 *   sort: [{ field: 'orderId': 'desc' }],
 *   page: 40,
 *   per_page: 80
 * }).then(data => { ... })
 *
 * @param {Object} [$axios=axios] Axios instance.
 * @param {String} id User id.
 * @param {Object[]} [options={}] Options to supply the endpoint
 * @param {Object} [options[].filter=undefined]
 *    Filter data returned from the API.
 *    Supported filters: [
 *        brand, dateFrom, dateTo, orderId, purchase, transactionId, type
 *    ]
 * @param {Number} [options[].page=1] Which page of data to fetch.
 * @param {Number} [options[].per_page=20] How many items to  display per page
 * @param {Array} [options[].sort=dateDesc] Result sort order
 * @param {Boolean} [options.includeTeamTransactions=false] Whether to include the other team members transactions (only if you're admin)
 * @returns {Promise} Unresolved Promise from the API.
 * @throws {Error} If no userId provided
 */
function allByUserId(axios, userId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!userId) {
    throw new Error('Prop `userId` is required in `transactionReports.allByUserId`');
  }
  var defaultParams = {
    includeTeamTransactions: false,
    page: 1,
    per_page: 20,
    sort: [{
      field: 'date',
      direction: 'desc'
    }]
  };
  var params = getParams(options, defaultParams, {
    filterColumnMap: filterColumnMap,
    sortColumnMap: sortColumnMap
  });
  return axios.get(urls.apiV2("/report/transactions/user/".concat(userId)), {
    params: params
  }).then(prop('data')).then(formatAllResponse);
}
export default {
  allByUserId: withAxios(allByUserId)
};